import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SignatoryInput.html?raw';

import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import lang from 'dojo/_base/lang';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import pdfYousign from '../../fileEditor/pdfYousign/pdfYousign';
import { SignatureAddress, SignatureLanguage } from "../DigitalSignatureTypes";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import Edit from '../../../moreCore/UI/Edit/Edit';

class SignatoryInput extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private inputID: number;
    private signatoryKey: string;
    private emailKey: string;
    private languageKey: string;
    private idKey: string;
    private statusKey: string;
    private urlKey: string;
    private mailSendKey: string;
    private signatureFieldKey: string;
    private mentionFieldKey: string;
    private signatureFieldSetKey: string;
    private mentionFieldSetKey: string;

    private isManualKey: string;
    private salutationKey: string;
    private firstnameKey: string;
    private lastnameKey: string;

    private heading: HTMLElement;

    private inputSignatory: MdsLax<InstanceType<typeof HintBox>>;
    private inputSignatoryLanguageCode: MdsLax<InstanceType<typeof SearchSelect>>;

    private inputIsManual: MdsLax<InstanceType<typeof CheckBox>>;
    private inputSalutation: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputFirstname: MdsLax<InstanceType<typeof Edit>>;
    private inputLastname: MdsLax<InstanceType<typeof Edit>>;
    private inputEmail: MdsLax<InstanceType<typeof Edit>>;

    private containerAddressMode: HTMLDivElement;

    private fieldplacementBtn: HTMLButtonElement;
    private sendLinkBtn: HTMLButtonElement;

    private isPlaceSignatureFieldBtnEnabled: boolean = false;
    private isRemoveSignatureFieldBtnEnabled: boolean = false;
    private isPlaceMentionFieldBtnEnabled: boolean = false;
    private isRemoveMentionFieldBtnEnabled: boolean = false;

    constructor(inputID: number) {
        super(...(arguments as unknown as []));
        this.inputID = inputID;

        switch (inputID) {
            case 1:
                this.signatoryKey = "ref_signatory";
                this.emailKey = "mail_address_signer";
                this.languageKey = "ref_language_signer";
                this.idKey = "signer_id";
                this.statusKey = "ref_status_signature_entity_signer_1.code";
                this.urlKey = "signature_entity_url";
                this.mailSendKey = "is_mail_send_signer_1";
                this.signatureFieldKey = "signature_field_1";
                this.signatureFieldSetKey = "signature_field_1_set";
                this.mentionFieldKey = "mention_field_1"
                this.mentionFieldSetKey = "mention_field_1_set";
                this.isManualKey = "is_manual_signer";
                this.salutationKey = "signer_salutation";
                this.firstnameKey = "signer_name_first";
                this.lastnameKey = "signer_name";
                break;
            case 2:
            case 3:
            case 4:
                this.signatoryKey = `ref_signatory_${inputID}`;
                this.emailKey = `mail_address_signer_${inputID}`;
                this.languageKey = `ref_language_signer_${inputID}`;
                this.idKey = `signer_id_${inputID}`;
                this.statusKey = `ref_status_signature_entity_signer_${inputID}.code`;
                this.urlKey = `signature_entity_url_${inputID}`;
                this.mailSendKey = `is_mail_send_signer_${inputID}`;
                this.signatureFieldKey = `signature_field_${inputID}`;
                this.signatureFieldSetKey = `signature_field_${inputID}_set`;
                this.mentionFieldKey = `mention_field_${inputID}`;
                this.mentionFieldSetKey = `mention_field_${inputID}_set`;
                this.isManualKey = `is_manual_signer_${inputID}`;
                this.salutationKey = `signer_salutation_${inputID}`;
                this.firstnameKey = `signer_name_first_${inputID}`;
                this.lastnameKey = `signer_name_${inputID}`;
                break;
            default:
                console.error("Error: Invalid input ID");
                return;
        }
    }


    disableFieldPlacmeentButton(bDisable: boolean = true): void {
        this.disableNode(this.fieldplacementBtn, bDisable);
    }

    private _onClickFieldPlacementBtn(evt: MouseEvent) {
        let floatingMenu = new FloatingMenu();
        floatingMenu.addEntry({ label: "DigitalSignature_Label_PlaceSignatureField", enabled: this.isPlaceSignatureFieldBtnEnabled, callback: lang.hitch(this, this._onClickAddSignatureField), icon: "fas fa-bullseye" }, "signature");
        floatingMenu.addEntry({ label: "DigitalSignature_Label_RemoveSignatureField", enabled: this.isRemoveSignatureFieldBtnEnabled, callback: lang.hitch(this, this._onClickRemoveSignatureField), icon: "fas fa-trash warningTXT" }, "signature");
        floatingMenu.addEntry({ label: "DigitalSignature_Label_PlaceMentionField", enabled: this.isPlaceMentionFieldBtnEnabled, callback: lang.hitch(this, this._onClickAddMentionField), icon: "fas fa-bullseye" }, "mention");
        floatingMenu.addEntry({ label: "DigitalSignature_Label_RemoveMentionField", enabled: this.isRemoveMentionFieldBtnEnabled, callback: lang.hitch(this, this._onClickRemoveMentionField), icon: "fas fa-trash warningTXT" }, "mention");
        floatingMenu.open(evt);
    }

    private _onClickAddSignatureField(evt: MouseEvent): void {
        let id = this.getAttributeValue("ID");
        let fileID = this.getAttributeValue("ref_vt_file.ID");

        let signatureObjectEditor = new pdfYousign();
        signatureObjectEditor.on("saved", lang.hitch(this, this.setSignatureField));
        signatureObjectEditor.loadSignatureObject(id, true, { type: "signature", ids: [this.inputID] });
    }

    private setSignatureField(documentEditorResponse: { signature_field_1?: string, signature_field_2?: string, signature_field_3?: string, signature_field_4?: string }): void {
        this.setAttributeValue(this.signatureFieldKey, documentEditorResponse[this.signatureFieldKey]);
        let isFieldSet = documentEditorResponse[this.signatureFieldKey] ? true : false;
        this.setAttributeValue(this.signatureFieldSetKey, isFieldSet);
    }

    private setMentionField(documentEditorResponse: { mention_field_1?: string, mention_field_2?: string, mention_field_3?: string, mention_field_4?: string }): void {
        this.setAttributeValue(this.mentionFieldKey, documentEditorResponse[this.mentionFieldKey]);
        let isFieldSet = documentEditorResponse[this.mentionFieldKey] ? true : false;
        this.setAttributeValue(this.mentionFieldSetKey, isFieldSet);
    }

    private _onClickRemoveSignatureField(evt: MouseEvent): void {
        this.StandbyStart();

        let payload = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname"),
            fieldID: this.inputID
        }

        this.RequestManager.callfunction("Webtool_API_DigitalSignature__DigitalSignatureEditor_RemoveSingatureField", payload, lang.hitch(this, this._onRemoveSignatureFieldResponse), lang.hitch(this._onRemoveSignatureFieldError));
    }

    private _onRemoveSignatureFieldResponse(response: {
        message: string,
        signature_field_1?: string,
        signature_field_1_set?: boolean,
        signature_field_2?: string,
        signature_field_2_set?: boolean,
        signature_field_3?: string,
        signature_field_3_set?: boolean,
        signature_field_4?: string,
        signature_field_4_set?: boolean
    }): void {
        this.setAttributeValue(this.signatureFieldKey, response[this.signatureFieldKey]);
        this.setAttributeValue(this.signatureFieldSetKey, response[this.signatureFieldSetKey]);

        this.showToast("DigitalSignatureEditor_Success_RemoveSignatureField", "fas fa-check");

        this.StandbyStop();
    }

    private _onRemoveSignatureFieldError(error): void {
        this.StandbyStop();
        this.showToast(error, "fas fa-exclamation-triangle");
    }

    private _onClickAddMentionField(evt: MouseEvent): void {
        let id = this.getAttributeValue("ID");
        let fileID = this.getAttributeValue("ref_vt_file.ID");

        let signatureObjectEditor = new pdfYousign();
        signatureObjectEditor.on("saved", lang.hitch(this, this.setMentionField));
        signatureObjectEditor.loadSignatureObject(id, true, { type: "mention", ids: [this.inputID] });
    }

    private _onClickRemoveMentionField(evt: MouseEvent): void {
        this.StandbyStart();

        let payload = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname"),
            fieldID: this.inputID
        }
        this.RequestManager.callfunction("Webtool_API_DigitalSignature__DigitalSignatureEditor_RemoveMentionField", payload, lang.hitch(this, this._onRemoveMentionFieldResponse), lang.hitch(this._onRemoveMentionFieldError));
    }

    private _onRemoveMentionFieldResponse(response: {
        message: string,
        mention_field_1?: string,
        mention_field_1_set?: boolean,
        mention_field_2?: string,
        mention_field_2_set?: boolean,
        mention_field_3?: string,
        mention_field_3_set?: boolean,
        mention_field_4?: string,
        mention_field_4_set?: boolean
    }): void {
        this.setAttributeValue(this.mentionFieldKey, response[this.mentionFieldKey]);
        this.setAttributeValue(this.mentionFieldSetKey, response[this.mentionFieldSetKey]);

        this.StandbyStop();

        this.showToast("DigitalSignatureEditor_Success_RemoveMentionField", "fas fa-check");
    }

    private _onRemoveMentionFieldError(error): void {
        this.StandbyStop();
        this.showToast(error, "fas fa-exclamation-triangle");
    }

    private _onClickSendLink(evt: MouseEvent) {
        this.RequestManager.callfunction("Webtool_API_DigitalSignature__DigitalSignatureEditor_SendMail", { type: "signer", id: this.inputID }, lang.hitch(this, this._onSendMailResponse), lang.hitch(this, this._onSendMailError));
    }

    private _onSendMailResponse(response): void {
        console.log(response);
    }

    private _onSendMailError(error): void {
        console.error(error);
    }

    protected _onChanged(attribute: string, value: any): void {
        switch (attribute) {
            case this.signatoryKey:
                this.setSignatoryValues(value);
                break;
            case this.isManualKey:
                this._toggleManualMode(value, false);
                break;
        }

        let changedData = this.getChangedData();
        this.emit("changed", changedData);

        if (this.isDirty()) this.disableEmailButton(this.isDirty());
        this.handleButtonStates();
    }

    private setSignatoryValues(value: any, isAfterLoad: boolean = false) {
        switch (value?.Classname) {
            case "persons":
                this.setAttributeValue(this.emailKey, value?.ref_vw_telecom_addresses?.emailaddress);
                this.setAttributeValue(this.salutationKey, value?.ref_salutation);
                this.setAttributeValue(this.firstnameKey, value?.name_first);
                this.setAttributeValue(this.lastnameKey, value?.name);
                break;
            case "associates":
            case "contact_persons":
                this.setAttributeValue(this.emailKey, value?.ref_vw_telecom_addresses?.emailaddress);
                this.setAttributeValue(this.salutationKey, value?.ref_person?.ref_salutation);
                this.setAttributeValue(this.firstnameKey, value?.ref_person?.name_first);
                this.setAttributeValue(this.lastnameKey, value?.ref_person?.name);
                break;
            default:
                if (this.getAttributeValue(this.isManualKey) && isAfterLoad) {
                    this.setAttributeValue(this.emailKey, this.getAttributeValue(this.emailKey));
                    this.setAttributeValue(this.salutationKey, this.getAttributeValue(this.salutationKey));
                    this.setAttributeValue(this.firstnameKey, this.getAttributeValue(this.firstnameKey));
                    this.setAttributeValue(this.lastnameKey, this.getAttributeValue(this.lastnameKey));
                } else {
                    this.setAttributeValue(this.emailKey, null);
                    this.setAttributeValue(this.salutationKey, null);
                    this.setAttributeValue(this.firstnameKey, null);
                    this.setAttributeValue(this.lastnameKey, null);
                }
                break;
        }
    }

    private _toggleManualMode(isManual: boolean, isAfterLoad: boolean = true): void {
        if (isManual) {
            this.hideNode(this.containerAddressMode);
            if (!isAfterLoad) {
                this.setAttributeValue(this.signatoryKey, null);
                this.setAttributeValue(this.salutationKey, null);
                this.setAttributeValue(this.firstnameKey, null);
                this.setAttributeValue(this.lastnameKey, null);
                this.setAttributeValue(this.emailKey, null);
            }
        } else {
            this.hideNode(this.containerAddressMode, false);
            if (!isAfterLoad) {
                let signatory = this.getAttributeValue(this.signatoryKey);
                this.setSignatoryValues(signatory);
            }
        }
        this.inputSalutation.setReadonly(!isManual);
        this.inputFirstname.setReadonly(!isManual);
        this.inputLastname.setReadonly(!isManual);
        this.inputEmail.setReadonly(!isManual);
    }

    private _loadLanguageValues(currentValue: SignatureLanguage): void {
        this.RequestManager.callfunction("Webtool_API_DigitalSignature__DigitalSignatureEditor_GetLanguageCodes", {}, lang.hitch(this, this._onLoadLanguageValuesResponse, currentValue), lang.hitch(this, this._onLoadLanguageValuesError));
    }

    private _onLoadLanguageValuesResponse(currentValue: SignatureLanguage, response: Array<SignatureLanguage>): void {
        this.inputSignatoryLanguageCode.setData(currentValue, response, true);
    }

    private _onLoadLanguageValuesError(error): void {
        console.error(error);
    }

    private _loadSalutationValues(currentValue: SignatureLanguage): void {
        this.RequestManager.callfunction("Webtool_API_DigitalSignature__DigitalSignatureEditor_GetSalutations", {}, lang.hitch(this, this._onLoadSalutationValuesResponse, currentValue), lang.hitch(this, this._onLoadSaltuationValuesError));
    }

    private _onLoadSalutationValuesResponse(currentValue: SignatureLanguage, response: Array<SignatureLanguage>): void {
        this.inputSalutation.setData(currentValue, response, true);
    }

    private _onLoadSaltuationValuesError(error): void {
        console.error(error);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let isManual = this.getAttributeValue(this.isManualKey);
        this._toggleManualMode(!!isManual, true);

        let language = this.getAttributeValue(this.languageKey);
        this._loadLanguageValues(language);

        let salutation = this.getAttributeValue(this.salutationKey);
        this._loadSalutationValues(salutation);

        this.handleButtonStates();
    }

    private handleButtonStates(): void {
        let link = this.getAttributeValue(this.urlKey);
        let hasLink = link ? true : false;
        this.disableEmailButton(!hasLink);

        let hasAnchor = this.getAttributeValue("is_document_with_anchors")
        this.disableFieldPlacmeentButton(hasAnchor);

        let isSignatureFieldSet = this.getAttributeValue(this.signatureFieldSetKey);
        let isMentionFieldSet = this.getAttributeValue(this.mentionFieldSetKey);


        this.disableAddMentionFieldBtn(hasLink);
        this.disableRemoveMentionFieldBtn(hasLink || !isMentionFieldSet);
        this.disableAddSignatureFieldBtn(hasLink);
        this.disableRemoveSignaturFieldeBtn(hasLink || !isSignatureFieldSet);
    }

    protected onDirtyChange(newState: boolean): void {
        //this.disableEmailButton(newState);
    }

    private disableEmailButton(disable: boolean): void {
        this.disableNode(this.sendLinkBtn, disable);
    }

    private disableAddSignatureFieldBtn(disable: boolean): void {
        this.isPlaceSignatureFieldBtnEnabled = !disable;
    }

    private disableRemoveSignaturFieldeBtn(disable: boolean): void {
        this.isRemoveSignatureFieldBtnEnabled = !disable;
    }

    private disableAddMentionFieldBtn(disable: boolean): void {
        this.isPlaceMentionFieldBtnEnabled = !disable;
    }

    private disableRemoveMentionFieldBtn(disable: boolean): void {
        this.isRemoveMentionFieldBtnEnabled = !disable;
    }

    private _onClickSED(mode: string, evt: MouseEvent) {
        this.showSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<SignatureAddress>>): void {
        console.log(items);

        if (!items || items.length === 0) return;

        let entity;
        switch (mode) {
            case "selectSigner":
                entity = items[0].entry.data;
                this.setAttributeValue(this.signatoryKey, entity);
                break;
        }
    }

    setReadonly(readonly?: boolean | "initial"): void {
        super.setReadonly.apply(this, arguments as any);

        this.disableEmailButton(readonly === "initial" || readonly);
        this.disableFieldPlacmeentButton(readonly === "initial" || readonly);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.heading.innerHTML = this.translate(`DigitalSignature_Label_Signatory${this.inputID}`);

        this.SEDconfigCallfunction = "Webtool_API_DigitalSignature__DigitalSignatureEditor_GetSEDConfig";
        this.inputSignatory.addInlineButton(lang.hitch(this, this._onClickSED, "selectSigner"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(SignatoryInput);
